// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3a36bd4","879":"bd876a4d"}[chunkId] + ".chunk.js";
};